import intlTelInput from 'intl-tel-input'

const setPhoneMask = (): void => {
  const input:HTMLInputElement | null = document.querySelector('#your-phone')
  if (input) {
    intlTelInput(input, {
      initialCountry: 'auto',
      strictMode: true,
      nationalMode: true,
      separateDialCode: true,
      autoPlaceholder: 'polite',
      geoIpLookup: function (callback: (countryCode: string) => void): void {
        fetch('https://ipinfo.io/json')
          .then(response => response.json())
          .then(data => callback(data.country))
          .catch(() => callback('us'))
      },
      //@ts-ignore
      loadUtilsOnInit: () => import('intl-tel-input/utils') //FIXME check import
    })

    input.addEventListener('input', function () {
      const phoneInput: HTMLInputElement | null = document.querySelector('input[name="your-phone-hidden"]')
      const iti = intlTelInput.getInstance(input)
      if (phoneInput && iti) {
        phoneInput.value =  iti.getNumber()
      }
    })
  }
}

export default setPhoneMask
